require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./5-yearsof-winpe.json") })
        }
      }, "path---5-yearsof-winpe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---5-yearsof-winpe!./.cache/json/5-yearsof-winpe.json
// module id = 1037
// module chunks = 231608221292675